goog.provide('el8.appchart.medsHx.util');

el8.appchart.medsHx.util = {
    HIGHLIGHT_CLASS: 'el8Highlight',
    SELECTED_CLASS: 'el8BlueHighlight'
};

